import React from 'react';
import { ArchivedOrders } from '@/components/dashboard/ArchivedOrders';
import { MobileAppShell } from '@/components/mobile/MobileAppShell';
import { useAdminAuth } from '@/hooks/useAdminAuth';
import { useNavigate } from 'react-router-dom';
import { Order } from "@/hooks/useOrdersManagement/types";

export const ArchivedOrdersPage = () => {
  const { isAdminAuthenticated } = useAdminAuth();
  const navigate = useNavigate();

  const handleViewProducts = (order: Order) => {
    navigate(`/order/${order.id}/workstation`);
  };

  if (!isAdminAuthenticated) {
    return (
      <div className="flex items-center justify-center min-h-96">
        <div className="text-center">
          <h2 className="text-lg font-semibold text-muted-foreground">Access Denied</h2>
          <p className="text-sm text-muted-foreground">Admin authentication required.</p>
        </div>
      </div>
    );
  }

  return <ArchivedOrders onViewProducts={handleViewProducts} />;
};